import React from "react";
import ConfiguratorOption from "../ConfiguratorOption";
import Wandmontage from '../../images/2/reactcode/Wandmontage';
import Freistehend from '../../images/2/reactcode/Freistehend';


interface ProductInstallationProps {
  selectedType: string;
  onSelectType: (type: string) => void;
}

const ProductInstallation: React.FC<ProductInstallationProps> = ({ selectedType, onSelectType }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 gap-x-2 gap-y-2 w-full">
      <ConfiguratorOption
        label="Wandmontage"
        imageMobile={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/carport.svg`}
        imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/desktop/Carport.svg`}
        onClick={() => onSelectType("Wandmontage")}
        isSelected={selectedType === "Wandmontage"}
        SVGComponent={Wandmontage}
      />
      <ConfiguratorOption
        label="Freistehend"
        imageMobile={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/image_4_new.svg`}
        imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/desktop/Carport.svg`}
        onClick={() => onSelectType("Freistehend")}
        isSelected={selectedType === "Freistehend"}
        SVGComponent={Freistehend}
      />
    </div>
  );
};

export default ProductInstallation;
